{
  "version": 1,
  "asset_id": "60e8e7d5-d499-4b35-8924-ff9b47eba53b",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/60e8e7d5-d499-4b35-8924-ff9b47eba53b/electrical-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/60e8e7d5-d499-4b35-8924-ff9b47eba53b/electrical-card.webp",
  "original_filename": "electrical-card.webp",
  "size": 42268,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:05Z"
}
